<!-- Serial Number Section -->
<nz-card *ngIf="serialType === 'SO' || serialType === 'SN'" nzTitle="Serial Number">
  <p>Please provide serial number of main PBX for allocation</p>
  <p>Please enter 12 characters for each license purchased</p>

  <div *ngFor="let serial of serials; let i = index; trackBy: trackByIndex" class="serial-row">
    <label class="serial-label">Serial {{ i + 1 }}:</label>
    <input nz-input [(ngModel)]="serials[i]" [placeholder]="'XXX123456789'" [disabled]="useMainPBX[i]" maxlength="12"
      class="serial-input" />

    <label *ngIf="serialType === 'SN'" nz-checkbox [(ngModel)]="useMainPBX[i]" (ngModelChange)="toggleCheckbox(i)" class="serial-check">
      Use serial number from main PBX unit in Cart
    </label>

    <!-- Delete button if too many serials -->
    <button *ngIf="serials.length > serialCount" nz-button nzType="link" nzDanger (click)="deleteSerial(i)">
      Delete
    </button>
  </div>

  <button nz-button nzType="primary" (click)="onSubmit()" [disabled]="!canSubmit()">
    Submit
  </button>
</nz-card>

<!-- Yeastar ID Section -->
<nz-card *ngIf="serialType === 'YID'" nzTitle="Yeastar ID">
  <p>Please provide your main Yeastar Partner Portal ID for license allocation</p>

  <div class="serial-row">
    <label class="serial-label">Yeastar ID:</label>
    <input nz-input [(ngModel)]="yeastarId" placeholder="john_doe@email.com" />
  </div>

  <button nz-button nzType="primary" (click)="onSubmit()">Submit</button>
</nz-card>
